export interface IStatuses {
  IN_PROGRESS: 'in-progress';
  TIMEOUT: 'timeout';
  FAILURE: 'failure';
  SKIPPED: 'skipped';
  SUCCESS: 'success';
}

export const Statuses: IStatuses = {
  IN_PROGRESS: 'in-progress',
  TIMEOUT: 'timeout',
  FAILURE: 'failure',
  SKIPPED: 'skipped',
  SUCCESS: 'success',
};
